import { connect } from 'react-redux';
import Dashboard from '../components/Dashboard';

const mapStateToProps = (state, ownProps) => ({
  subscriptions: state.account.subscriptions,
  hasSecureEdgeFeature: state.account.features.includes('secure_edge') || false, // state.account.features.includes('secure_edge') || false,
  msp: state.account.msps,
});

export default connect(
  mapStateToProps,
  undefined
)(Dashboard);
